module.exports = __webpack_public_path__ + "static/media/Wipro Select Medicare Advantage Only 91901.0a79cb46.pdf";